import { connect, ConnectedProps } from 'react-redux'
import TableServices from '../../../../../../../../specificComponents/Product/Tables/TableServices'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { CloseLateralModalSimple, ModalFullCentered } from '../../../../../../../Modal'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'


type ServiceListingModalProps = ReduxTableServices & ModalEditComponentProps & {}

const ServiceListingModal: React.FC<ServiceListingModalProps> = ({...rest}) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={()=> rest.setOpened(null)}/>
            <TableServicesConnect setTableInstance={() => { }} userPermissions={getUserPermissions('product.profile.main') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={() => rest.setOpened(null)}/>
        </ModalFullCentered>
    )
}


const servicesDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapServicesConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const servicesConnect = connect(mapServicesConnector, servicesDispatch)
type ReduxTableServices = ConnectedProps<typeof servicesConnect>

const servicesConnectLoading = withLoading(TableServices, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const TableServicesConnect = servicesConnect(servicesConnectLoading)

export default ServiceListingModal